import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { MealPage } from './pages/MealPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/meal" element={<MealPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}